export default __webpack_public_path__ + "static/media/increase_pain_smile.0d2eda7a.svg";